module.exports = __webpack_public_path__ + "img/ktb.db4e0c2f.svg";